module.exports = __webpack_public_path__ + "static/img/loader.cda2d4e6.gif";